import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { Instructivo } from '@/app/models/interface/instructivo.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class InstructivoService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'instructivo/';

  create(data: FormData) {
    return this.http.post<CustomResponse<Instructivo>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<CustomResponse<PaginatorModel<Instructivo[], HasPagination>>>(
        this.url,
        {
          params,
        },
      )
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data: d.data.map((d) => ({
                ...d,
              })),
            };
          }
          return d;
        }),
      );
  }

  findOne(id: number) {
    const url = this.url + id;
    return this.http.get<CustomResponse<Instructivo>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  update(tipo: FormData, id: number) {
    const url = this.url + id;
    return this.http.put<CustomResponse<Instructivo>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  changeState(state: boolean, id: number) {
    const url = this.url + id;
    return this.http.patch<CustomResponse<Instructivo>>(url, { state }).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }
}
